// utils/apiService.js
import axios from "axios";

export const BorrowerService = {
  fetchBorrowers: async (token, companyId = null) => {
    try {
      let url = "https://zedlenders.pickmesms.com/users?fields=id,first_name,last_name,credit_score,nrc&filter[role][name][_eq]=Borrower";
      
      // Add company filter if companyId is provided
      if (companyId) {
        url += `&filter[company]=${companyId}`;
      }
      
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return response.data.data;
    } catch (error) {
      console.error("Error fetching borrowers:", error);
      throw error; // Re-throw to handle in components
    }
  },

  fetchGovtBorrowers: async (token) => {
    const params = new URLSearchParams({
      fields: "id,first_name,last_name,credit_score",
      filter: JSON.stringify({
        _and: [
          { "role.name": { _eq: "Borrower" } },
          { employee_type: { _eq: "government" } },
        ],
      }),
    });

    try {
      const response = await axios.get(
        "https://zedlenders.pickmesms.com/users?fields=id,first_name,last_name,credit_score&filter[role][name][_eq]=Borrower&filter[employment_type][_eq]=government",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching government borrowers:", error);
      throw error;
    }
  },
};

export const CalendarService = {
  fetchEvents: async (token, userId, companyId) => {
    try {
      const url = `https://zedlenders.pickmesms.com/items/calendar_events?filter[user_id]=${userId}&filter[company_id]=${companyId}`;
      
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return response.data.data;
    } catch (error) {
      console.error("Error fetching calendar events:", error);
      throw error;
    }
  },

  createEvent: async (token, eventData) => {
    try {
      const response = await axios.post(
        "https://zedlenders.pickmesms.com/items/calendar_events",
        eventData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data.data;
    } catch (error) {
      console.error("Error creating calendar event:", error);
      throw error;
    }
  },

  updateEvent: async (token, eventId, eventData) => {
    try {
      const response = await axios.patch(
        `https://zedlenders.pickmesms.com/items/calendar_events/${eventId}`,
        eventData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data.data;
    } catch (error) {
      console.error("Error updating calendar event:", error);
      throw error;
    }
  },

  deleteEvent: async (token, eventId) => {
    try {
      await axios.delete(
        `https://zedlenders.pickmesms.com/items/calendar_events/${eventId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      console.error("Error deleting calendar event:", error);
      throw error;
    }
  },
};
